import { get } from "./fetchWrapper";

export function getDialogContent(artikelnummer, origin) {
  if (origin === "bestelleinstieg") {
    return get("/include/filialabholung/bestelleinstieg/filialauswahl/" + artikelnummer, "", 20000);
  }
  return get("/include/filialabholung/filialauswahl/" + artikelnummer + "?origin=" + origin, "", 20000);
}
